export const enseignantsConstants = {
  GET_ENSEIGNANTS: "GET_ENSEIGNANTS",
  GET_ENSEIGNANT: "GET_ENSEIGNANT",
  GET_CONTRATS: "GET_CONTRATS",
  GET_CONTRAT: "GET_CONTRAT",

  GET_AVENANT: "GET_AVENANT",
  GET_EVALUATION: "GET_EVALUATION",
};
